// extracted by mini-css-extract-plugin
export var modal = "_db-0";